import React, { useEffect, useState } from "react";
import TitleSection from "../title-section";
import { saveForm, getToken } from "../../../services/formServices";
import { getAllMunicipalities } from "../../../services/municipalities";
import FormModal from "../../ui/modal/Modal";
import { navigate } from "gatsby";
import Button from "../../atoms/button/button";
import contentfulRenderOptions from "../../../utils/contentfulRenderOption";
import FormBodyContactar from "../form-body-contactar/FormBodyContactar";
import ModalRegistroForm from "../modal-registro-form/modalRegistroForm";
import moment from "moment";

// Styles //
import "./contactarCard.scss";

type ContactarCardProps = {
    tituloPrincipal?: string;
    descripcionFormulario?: any;
    titulosFormulario: Array<any>;
    modalSuccess: any;
    talentName: string;
    modalCancelar: any;
    listSelectedTalents: any;
    isIndividual: any;
    setListSelectedTalents: any;
    messageTalent: any;
    modalFailure: any;
    setActivateToast: any;
};

function ContactarCard(props: ContactarCardProps) {

    const {
        tituloPrincipal,
        descripcionFormulario,
        titulosFormulario,
        modalSuccess,
        talentName,
        modalCancelar,
        listSelectedTalents,
        isIndividual,
        setListSelectedTalents,
        messageTalent,
        modalFailure,
        setActivateToast
    }= props;

    const defaultFormValues = {
        application_date: '',
        talent_name: '',
        location: '',
        education_level: '',
        profession: ''
    }

    const [formValues, setFormValues] = useState(defaultFormValues);
    const [isDisabledButton, setIsDisabledButton] = useState<boolean>(false);
    const [inputDisabled] = useState<string[]>([]);
    const [closeForm, setCloseForm] = useState(false);
    const [isOpenModalSuccess, setIsOpenModalSuccess] = useState<boolean>(false);
    const [titulosFormularioHelper] = useState(titulosFormulario);
    const idFormIndividual = 14;
    const idFormGrupal = 15;
    const [isOpenModalFailure, setIsOpenModalFailure] = useState<boolean>(false);
    const [mensajeError, setMensajeError] = useState("");
  
    const handleCloseForm = () =>{
        setCloseForm(true);
    }

    //Validaciones para los inputs
    const inputRegexValidation = (field: any, value: any) => {
        // Evita que el usuario incluya caracteres no alfabeticos
        if (field === "contact_name" || field === "position") {
            const re = /^[ a-zA-ZÀ-ÿ\u00f1\u00d1]*$/g;
            return re.test(value);
        } else if (field === "contact_number") {
            return value.length <= 10 ? true : false;
        }
        return true;
    };
    
    const updateInputValue = (field: string, value: any) => {
        if (inputRegexValidation(field, value)) {
            setFormValues((prev: any) => {
                return { ...prev, [field]: value };
            });
        }
    }

    const handleSubmitForm = () => {
        listSelectedTalents.forEach(selectedTalents => {
            if(listSelectedTalents.length > 1){
                persistDataForEachTalent(selectedTalents, idFormGrupal)
            }else{
                persistDataForEachTalent(selectedTalents, idFormIndividual)
            }
        })
    };

    const persistDataForEachTalent = async (selectedTalent, formId) => {
        setIsDisabledButton(true);

        const payload = createPayload(selectedTalent, formId);
        const token = await getToken(null);
        const response = await saveForm(payload, token);

        if(response.data.status === 200){
            setIsOpenModalSuccess(true);
        }
        
        if(response.data.status >= 400 && response.data.status < 500){
            setMensajeError(modalFailure.descripcion);
            setIsOpenModalFailure(true);
        }

        if(response.data.status >= 500 && response.data.status < 600){
            setMensajeError(modalFailure.descripcionFormulario);
            setIsOpenModalFailure(true);
        } 

        setIsDisabledButton(false);
    };

    const createPayload = (selectedTalent, formId) => {
        const payload: any = {
            idForm: formId,
            answers: [],
        };

        Object.entries(formValues).forEach(([key, value]) => {
            payload.answers.push({ contentfulId: key, answer: value });
        });

        const applicationDate = moment(Date.now()).format('DD-MM-YYYY');

        payload.answers.forEach((answer) => {
            if (answer["contentfulId"] == "dataProcessingAuthorization") {
                answer["answer"] === true
                ? answer["answer"] = "SI"
                : answer["answer"] = "NO";
            }
            if (answer["contentfulId"] == "application_date") {
                answer["answer"] = applicationDate;
            }
            if (answer["contentfulId"] == "talent_name") {
                answer["answer"] = selectedTalent.nombres + " " + selectedTalent.apellidos;
            }
            if (answer["contentfulId"] == "location") {
                answer["answer"] = selectedTalent.municResidencia;
            }
            if (answer["contentfulId"] == "education_level") {
                answer["answer"] = String(selectedTalent.nivelEducativo?.map(i => i.nivelAcademico));
            }
            if (answer["contentfulId"] == "profession") {
                answer["answer"] = String(selectedTalent.nivelEducativo?.map(i => i.tituloProfesional));
            }
        });   
        
        return payload;
    }; 

    const municipalitiesList = async () => {
        try {
            setIsDisabledButton(true);
            const data = await getAllMunicipalities();
            const municipalities : any[] = [];
            Object.entries(data.data.data).forEach(([key, value]) => {
                municipalities.push(value.name + " - " + value.departmentDTO.name);
            });
            municipalities.sort();

            // Agrega los municipalities como options al campo de tipo select correspondiente
            Object.entries(
                titulosFormularioHelper[0].referenciaFormulario
            ).forEach(([key, value]) => {
                if (value.nombreId === "municipalities") {
                    titulosFormularioHelper[0].referenciaFormulario[
                        key
                    ].listaSelect = municipalities;
                }
            });
            setIsDisabledButton(false);

        } catch (error) {
            console.log("API Error:", error);
        }
    };

    useEffect(() => {
        municipalitiesList();
    }, []);

    return (
        <div className={`m-contactar-card${(isOpenModalSuccess || isOpenModalFailure) ? "__modalRegistro" : ""}`}>
            {/* Renderiza el modal */}
            {(!isOpenModalSuccess && !isOpenModalFailure) && (
                <>
                <div className="m-contactar-card__header">
                    <TitleSection 
                        title={
                            `${ isIndividual
                            ? tituloPrincipal + " " + talentName 
                            : tituloPrincipal}`
                        } type = 'h6' 
                    />
                    <p className="m-subtitle-section">
                        {descripcionFormulario && (
                            contentfulRenderOptions(
                                descripcionFormulario,
                            )
                        )}
                    </p>
                </div>
                <div className="m-contactar-card__body">
                    <div className="m-contactar-card__body__content">
                        <FormBodyContactar
                            // Campos y estilos del formulario
                            titulosFormulario={titulosFormularioHelper}
                            setInputValue={updateInputValue}
                            formValues={formValues}
                            handleSubmitForm={handleSubmitForm}
                            inputDisabled={inputDisabled}
                            isDisabledButton={isDisabledButton}
                            handleBigCancelButton={handleCloseForm}
                            listSelectedTalents={listSelectedTalents}
                            setListSelectedTalents={setListSelectedTalents}
                            messageTalent={messageTalent}
                            setActivateToast={setActivateToast}
                        >
                            {closeForm && modalCancelar && (
                                <FormModal
                                    showModal={closeForm}
                                    onClose={() => {setCloseForm(false)}}>
                                    <div
                                        className={`m-modal-container-exit`}
                                    >
                                        <h3>{modalCancelar.tituloPrincipal}</h3>
                                        <div>
                                            <Button
                                                type="button"
                                                classname="m-modal-container-exit__go-back"
                                                text={modalCancelar.tituloBoton} 
                                                isDisabled={false}
                                                onClickAction={() => {setCloseForm(false)}}
                                            >
                                            </Button>
                                        </div>
                                        <div>
                                            <Button
                                                type="button"
                                                classname="m-modal-container-exit__cancel"
                                                text={modalCancelar.tituloBotonOpcional} 
                                                isDisabled={false}
                                                onClickAction={() => {
                                                    navigate(modalCancelar.redireccionBotonOpcional);
                                                }}
                                                >
                                            </Button>
                                        </div>
                                    </div>
                               </FormModal>
                            )}
                        </FormBodyContactar>
                    </div>
                </div>
                </>
            )}
            {/* Renderiza el modal para el registro exitoso */}
            {isOpenModalSuccess && (
                <ModalRegistroForm
                    showModal={isOpenModalSuccess} 
                    tituloPrincipal={
                        isIndividual 
                        ? modalSuccess.tituloPrincipal
                        : modalSuccess.tituloFormulario
                    }
                    descripcionFormulario={
                        isIndividual 
                        ? modalSuccess.descripcionFormulario
                        : modalSuccess.descripcion
                    }
                    imagenesFormulario={modalSuccess.imagenesEmpleo}
                    tituloBoton={modalSuccess.tituloBoton}
                    redireccionBoton={modalSuccess.redireccionBoton}
                />
            )}
            {/* Renderiza el modal para el registro fallido */}
            {isOpenModalFailure && (
                <ModalRegistroForm
                    showModal={isOpenModalFailure} 
                    tituloPrincipal={modalFailure.tituloPrincipal}
                    descripcionFormulario={mensajeError}
                    imagenesFormulario={modalFailure.imagenFormulario}
                    tituloBoton={modalFailure.tituloBoton}
                    redireccionBoton={modalFailure.redireccionBoton}
                    isOpenModalFailure={isOpenModalFailure}
                />
            )}
        </div>
    );
}

export default ContactarCard;